<template>
    <div>
        <LoadingWidget v-if="initStatusAdmin != 1" :status="initStatusAdmin" @init="init" />
        <b-form @submit.prevent="openModalConfirm" v-else>
            <div class="form-parameter-wrapper">
                <b-form-group
                    label-cols-sm="12"
                    label-cols-lg="3"
                    label="Eksekutor Pertama Barang Hilang" 
                    label-align="left"
                    >
                    <b-row class="parameter-admin-wrapper">
                        <b-col>
                            <div class="admin-wrapper-data d-flex align-items-center">
                                <p class="mb-0">{{input.eks1Name}}</p>
                                <b-button variant="pgiBtn" @click="openModalEks(1)">
                                    <i class="fa fa-edit mr-1"></i>
                                    Ubah
                                </b-button>
                            </div>
                            <span class="smallText text-muted">User yang dapat melakukan approval tingkat pertama untuk ajuan barang hilang. User ini akan mendapatkan akses menu Persetujuan > Barang Hilang.</span>
                        </b-col>
                    </b-row>
                </b-form-group>
                <b-form-group
                    label-cols-sm="12"
                    label-cols-lg="3"
                    label="Eksekutor Akhir Barang Hilang" 
                    label-align="left"
                    >
                    <b-row class="parameter-admin-wrapper">
                        <b-col>
                            <div class="admin-wrapper-data d-flex align-items-center">
                                <p class="mb-0">{{input.eks2Name}}</p>
                                <b-button variant="pgiBtn" @click="openModalEks(2)">
                                    <i class="fa fa-edit mr-1"></i>
                                    Ubah
                                </b-button>
                            </div>
                            <span class="smallText text-muted">User terakhir yang mengukuhkan ajuan barang hilang. User ini akan mendapatkan akses menu Persetujuan > Barang Hilang.</span>
                        </b-col>
                    </b-row>
                </b-form-group>
                <b-form-group
                    label-cols-sm="12"
                    label-cols-lg="3"
                    label="Notifikasi Pengajuan Kirim Balik" 
                    label-align="left"
                    >
                    <b-row class="parameter-admin-wrapper">
                        <b-col>
                            <div class="admin-wrapper-data d-flex align-items-center">
                                <p class="mb-0">{{input.notifKirimBalik}}</p>
                                <b-button variant="pgiBtn" @click="openModalEks(3)">
                                    <i class="fa fa-edit mr-1"></i>
                                    Ubah
                                </b-button>
                            </div>
                            <span class="smallText text-muted">User yang akan mendapatkan notifikasi bila terdapat cabang yang mengajukan pengiriman balik lelang</span>
                        </b-col>
                    </b-row>
                </b-form-group>
                <b-form-group
                    label-cols-sm="12"
                    label-cols-lg="3"
                    label="Approver Cek Gadai Emas Pusat" 
                    label-align="left"
                    >
                    <b-row class="parameter-admin-wrapper">
                        <b-col>
                            <div class="admin-wrapper-data d-flex align-items-center">
                                <p class="mb-0">{{input.approverEmas}}</p>
                                <b-button variant="pgiBtn" @click="openModalEks(4)">
                                    <i class="fa fa-edit mr-1"></i>
                                    Ubah
                                </b-button>
                            </div>
                            <span class="smallText text-muted">User yang akan mendapatkan notifikasi dan cek gadai untuk seluruh gadai emas</span>
                        </b-col>
                    </b-row>
                </b-form-group>
            </div>
            <div class="form-wrapper-btn submit-btn-wrapper">
                <b-button type="submit" name="parameterUpdateBtn" variant="pgiBtn">Update</b-button>
            </div>
            <b-modal id="modal-pilih-eks" title="Pilih Eksekutor">
                <div class="form-content-wrapper">
                    <b-form-group label="Eksekutor">
                        <div class="d-flex flex-wrap" style="gap: 8px;">
                            <multiselect
                                style="flex: 1 1 200px; min-width: 0;"
                                name="eksekutorData"
                                v-model="input.eksekutorData" 
                                :options="eksekutorData" 
                                :internal-search="false"
                                :loading="isLoadingEks"
                                @search-change="searchEks"
                                :allow-empty="false"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="*Ketik min. 4 huruf untuk mencari..."
                            />
                            <b-button variant="danger" class="flex-shrink-0" name="removeEks" @click="onRemoveEks">Hapus</b-button>
                        </div>
                    </b-form-group>
                </div>
                <template v-slot:modal-footer="{ cancel }">
                    <b-button variant="secondary" name="closeModalBtn" @click="cancel()">
                        Close
                    </b-button>
                    <b-button variant="pgiBtn" name="pilihEksBtn" @click="pilihEks()">
                        Pilih
                    </b-button>
                </template>
            </b-modal>
            <ModalConfirm id="modal-edit-administrasi" title="Confirm Edit Parameter Administrasi" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah parameter administrasi ini?" @submit="onSubmit" />
        </b-form>
    </div>
</template>

<script>
export default {
    name: 'administrasi',
    props: {
        administrasiInput: { type: Object, required: true }
    },
    data(){
        return{
            isSubmitting: false,
            initStatusAdmin: 0,
            newData: {},
            activeEksId: null,
            isLoadingEks: false,
            input:{
                eks1Name : "",
                eks2Name : "",
                notifKirimBalik: "",
                approverEmas: "",
                eksekutorData: null,
            },
            eksekutorData: [],
            activeSearchEks: null
        }
    },
    methods: {

        init(){
            this.initStatusAdmin = 0
            let idEks1 = this.administrasiInput.EKS_1_BARANG_HILANG
            let idEks2 = this.administrasiInput.EKS_2_BARANG_HILANG
            let notifKirimBalik = this.administrasiInput.NOTIF_KIRIM_BALIK
            let approverEmas = this.administrasiInput.APPROVER_CEK_GADAI_EMAS_PUSAT

            let getEks1 = this.$axios.get(`user/fullname/${idEks1}`).then(response => {
                this.input.eks1Name = response.data.name
            })
            let getEks2 = this.$axios.get(`user/fullname/${idEks2}`).then(response => {
                this.input.eks2Name = response.data.name
            })
            let getNotifKirimBalik = this.$axios.get(`user/fullname/${notifKirimBalik}`).then(response => {
                this.input.notifKirimBalik = response.data.name
            })
            let getApproverEmas = this.$axios.get(`user/fullname/${approverEmas}`).then(response => {
                this.input.approverEmas = response.data.name
            })
            Promise.all([getEks1, getEks2, getNotifKirimBalik,getApproverEmas]).then(() => {
                this.initStatusAdmin = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatusAdmin = -1
            })
        },
        //----------------- Fungsi Submit Data -----------------

        onSubmit() {

            this.newData = JSON.parse(JSON.stringify(this.administrasiInput))

            let payload = new FormData()
            
            for (let [key, value] of Object.entries(this.newData)) {
                payload.append("name", key)
                payload.append("value", value)
            }

            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true
            
            this.$axios.post("parameter/update/", payload).then(response => {
                this.$helper.toastSucc(this, "Parameter Administrasi telah berhasil diubah!")
                this.$bvModal.hide("modal-edit-administrasi")
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },
        
        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------
        
        openModalConfirm(){
            this.$bvModal.show("modal-edit-administrasi")
        },

        openModalEks(id){
            this.activeEksId = id
            this.$bvModal.show("modal-pilih-eks")
        },

        searchEks(searchQuery){
            if (searchQuery.length >= 4){
                this.isLoadingEks = true

                if (this.activeSearchEks == null) this.activeSearchEks = setTimeout(() => { this.searchEksFunc(searchQuery) }, 1000)
                else {
                    clearTimeout(this.activeSearchEks)
                    this.activeSearchEks = setTimeout(() => { this.searchEksFunc(searchQuery) }, 1000)
                }
            } 
            else {
                clearTimeout(this.activeSearchEks)
                this.activeSearchEks = null
                this.isLoadingEks = false
            }
        },

        searchEksFunc(searchQuery){
            this.$axios.get('user/search/?fullname='+searchQuery).then(response => {
                this.eksekutorData = response.data
                this.isLoadingEks = false
                this.activeSearchEks = null
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
        },

        pilihEks(){
            if(this.activeEksId == 1){
                this.input.eks1Name = this.input.eksekutorData.name
                this.administrasiInput.EKS_1_BARANG_HILANG = this.input.eksekutorData.id
            }else if(this.activeEksId == 2){
                this.input.eks2Name = this.input.eksekutorData.name
                this.administrasiInput.EKS_2_BARANG_HILANG = this.input.eksekutorData.id
            }else if(this.activeEksId == 3){
                this.input.notifKirimBalik = this.input.eksekutorData.name
                this.administrasiInput.NOTIF_KIRIM_BALIK = this.input.eksekutorData.id
            } else {
                this.input.approverEmas = this.input.eksekutorData.name
                this.administrasiInput.APPROVER_CEK_GADAI_EMAS_PUSAT = this.input.eksekutorData.id
            }
            this.input.eksekutorData = null
            this.$bvModal.hide("modal-pilih-eks")
        },

        onRemoveEks(id){
            this.input.eksekutorData = null
        },
    },
    created(){
        this.init()
    }
}
</script>